import React from "react";
import {
    Button,
    Modal,
    Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const AssetServicesDeleteModal = (props) => {
    const { open, toggleModal, deleteAssetServicesRecord, propertyManagementKey } = props;
        
    const toggleModalClose = () => {
        toggleModal(false);
    };

    const handleDelete = (propertyManagementKey) => {
        deleteAssetServicesRecord(propertyManagementKey);
        toggleModalClose();
    };
    
    return (
        <React.Fragment>
            <Modal
                aria-labelledby="asset-services-delete-modal"
                aria-describedby="deletes current asset services record"
                open={open}
                onClose={toggleModalClose}
            >
                <PaperStyle>
                    <ModalHeader variant="h5">
                        Delete Asset Services Record?
                    </ModalHeader>
                    <ModalContainer>
                        <div>
                            Are you sure you want to delete this record?
                            {<br />}
                            Once this record is deleted it cannot be recovered.
                        </div>
                        <CancelAndDeleteButtons
                            toggleModalClose={toggleModalClose}
                            handleDelete={() => handleDelete(propertyManagementKey)}
                        />
                    </ModalContainer>
                </PaperStyle>
            </Modal>
        </React.Fragment>
    );
}

const CancelAndDeleteButtons = (props) => {
    const { toggleModalClose, handleDelete } = props;
    return (
        <React.Fragment>
            <CancelAndDeleteButtonStyle>
                <Button variant="contained" color="default" onClick={toggleModalClose}>
                    Cancel
                </Button>
                <Button variant="contained" color="primary" onClick={handleDelete}>
                    Delete
                </Button>
            </CancelAndDeleteButtonStyle>
        </React.Fragment>
    );
};

const PaperStyle = styled('div')({
  display: "flex",
  flexDirection: "column",
  background: "white",
  top: "50%",
  left: "50%",
  width: "420px",
  height: "250px",
  transform: "translate(-50%, -50%)",
  position: "absolute",
  alignItems: "center",
  borderRadius: "3px",
  boxShadow: "0 3px 7px rgba(0, 0, 0, 0.3)",
});

const ModalHeader = styled(Typography)({
  alignSelf: "center",
  marginTop: "5%",
});

const ModalContainer = styled('div')({
  display: "flex",
  justifyContent: "space-around",
  flexDirection: "column",
  width: "90%",
  height: "90%",
});

const CancelAndDeleteButtonStyle = styled('div')({
  display: "flex",
  flexDirection: "row",
  alignSelf: "end",
});

export default AssetServicesDeleteModal;